/* BannerDetailsWidget.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Bleed, Inline, Stack, xcss } from '@atlaskit/primitives';
import React from 'react';
import { breakpointValues } from '../Breakpoints/Breakpoints';
import { useResponsiveBreakpoint } from '../hooks/useResponsiveBreakpoint/useResponsiveBreakpoint';
import { LinkWithIcon } from '../Links/Links';
import { BodySmall } from '../Typography/Typography';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _11 = "._vwz41j6v{line-height:1rem}";
const _10 = "._1wyboqnp{font-size:.75rem}";
const _9 = "._k48pi7a9{font-weight:var(--ds-font-weight-regular,400)}";
const _8 = "._k48pmoej{font-weight:var(--ds-font-weight-bold,700)}";
const _7 = "._2lx21bp4{flex-direction:column}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "._i0dlf1ug{flex-basis:0%}";
const _4 = "._1o9zkb7n{flex-shrink:1}";
const _3 = "._16jlkb7n{flex-grow:1}";
const _2 = "._4t3i1ylp{height:40px}";
const _ = "._1bsb1ylp{width:40px}";
const boxContainerStyles = xcss({
  paddingInline: 'space.300',
  paddingBlock: 'space.200',
  gap: 'space.100',
  borderTop: '1px solid',
  borderColor: 'color.border',
  marginTop: 'space.100'
});
const mobileBoxContainerStyles = xcss({
  paddingInline: 'space.300',
  paddingBlockStart: 'space.300',
  paddingBlockEnd: 'space.500',
  gap: 'space.100',
  borderTop: '1px solid',
  borderColor: 'color.border'
});
const headingStyles = null;
const subHeadingStyles = null;
const textStackStyles = null;
const iconContainerStyles = null;
export const BannerDetailsMobile = _ref => {
  let {
    iconImage,
    text,
    subText,
    ctaText,
    ctaHref,
    ctaType = 'internal',
    containerStyles,
    onCtaClick,
    ctaAriaLabel
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    xcss: [mobileBoxContainerStyles, containerStyles],
    alignBlock: "start",
    alignInline: "start",
    space: "space.200",
    testId: "banner-container",
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_1bsb1ylp _4t3i1ylp"]),
        children: /*#__PURE__*/_jsx("img", {
          src: iconImage,
          alt: "",
          "aria-hidden": "true"
        })
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_3, _4, _5, _6, _7]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_8]
          }), /*#__PURE__*/_jsx(BodySmall, {
            as: "span",
            className: ax(["_k48pmoej"]),
            children: text
          })]
        }), subText && /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_9, _10, _11]
          }), /*#__PURE__*/_jsx(BodySmall, {
            as: "span",
            className: ax(["_k48pi7a9 _1wyboqnp _vwz41j6v"]),
            children: subText
          })]
        })]
      })]
    }), ctaText && ctaHref ? /*#__PURE__*/_jsx(Bleed, {
      children: /*#__PURE__*/_jsx(Inline, {
        alignBlock: "center",
        alignInline: "start",
        shouldWrap: false,
        grow: "hug",
        children: /*#__PURE__*/_jsx(LinkWithIcon, {
          size: "small",
          type: ctaType,
          href: ctaHref,
          onClick: onCtaClick,
          "aria-label": ctaAriaLabel,
          children: ctaText
        })
      })
    }) : null]
  });
};
export const BannerDetailsGeneral = _ref2 => {
  let {
    iconImage,
    text,
    subText,
    ctaText,
    ctaHref,
    ctaType = 'internal',
    containerStyles,
    onCtaClick,
    ctaAriaLabel
  } = _ref2;
  return /*#__PURE__*/_jsxs(Inline, {
    xcss: [boxContainerStyles, containerStyles],
    testId: "banner-container",
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_1bsb1ylp _4t3i1ylp"]),
        children: /*#__PURE__*/_jsx("img", {
          src: iconImage,
          alt: "",
          "aria-hidden": "true"
        })
      })]
    }), /*#__PURE__*/_jsxs(Inline, {
      alignBlock: "center",
      alignInline: "start",
      shouldWrap: false,
      grow: "fill",
      space: "space.200",
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_3, _4, _5, _6, _7]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4"]),
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_8]
            }), /*#__PURE__*/_jsx(BodySmall, {
              as: "span",
              className: ax(["_k48pmoej"]),
              children: text
            })]
          }), subText && /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_9, _10, _11]
            }), /*#__PURE__*/_jsx(BodySmall, {
              as: "span",
              className: ax(["_k48pi7a9 _1wyboqnp _vwz41j6v"]),
              children: subText
            })]
          })]
        })]
      }), ctaText && ctaHref ? /*#__PURE__*/_jsx(Bleed, {
        children: /*#__PURE__*/_jsx(Inline, {
          alignBlock: "center",
          alignInline: "center",
          shouldWrap: false,
          grow: "hug",
          children: /*#__PURE__*/_jsx(LinkWithIcon, {
            size: "small",
            type: ctaType,
            href: ctaHref,
            onClick: onCtaClick,
            "aria-label": ctaAriaLabel,
            children: ctaText
          })
        })
      }) : null]
    })]
  });
};

// React
export const BannerDetailsWidget = props => {
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  return isMobile ? /*#__PURE__*/_jsx(BannerDetailsMobile, _objectSpread({}, props)) : /*#__PURE__*/_jsx(BannerDetailsGeneral, _objectSpread({}, props));
};